import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';

import { UiStore } from '../state/ui.store';

/** Numara cererile HTTP in curs, pentru bara de incarcare din navigatie. */
export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
    const uiStore = inject(UiStore);
    uiStore.startLoading();
    return next(req).pipe(finalize(() => uiStore.stopLoading()));
};
